import React, { Component } from 'react';
import Select from "react-select";
import Swal from "sweetalert2/dist/sweetalert2.js";

// Debe reflejar FormatTaskFieldMapping::COMPATIBLE_TYPES (backend autoritativo).
const TASK_FIELDS = [
    { key: "name", label: "Título", types: ["answer_string", "answer_text", "answer_integer"] },
    { key: "description", label: "Descripción", types: ["answer_string", "answer_text"] },
    { key: "user_owner_id", label: "Responsable", types: ["answer_user_id"] },
    { key: "due_date", label: "Fecha", types: ["answer_date", "answer_datetime"] },
    { key: "start_time", label: "Hora inicio", types: ["answer_time", "answer_hour"] },
    { key: "end_time", label: "Hora fin", types: ["answer_time", "answer_hour"] },
    { key: "priority", label: "Prioridad", types: ["answer_integer", "answer_select", "answer_radio"] },
    { key: "label", label: "Etiqueta", types: ["answer_select", "answer_radio", "answer_checkbox"] },
];

const STATUS_QUESTION_TYPES = ["answer_select", "answer_radio"];

class Index extends Component {
    constructor(props) {
        super(props);
        this.token = document.querySelector("[name='csrf-token']").content;
        this.state = {
            isLoaded: true,
            config: null,
            questions: [],
            columns: [],
            statusOptions: [],
        };
    }

    componentDidMount() {
        this.loadConfig();
    }

    request = (url, method, body) => {
        return fetch(url, {
            method,
            body: body ? JSON.stringify(body) : undefined,
            headers: { "X-CSRF-Token": this.token, "Content-Type": "application/json" }
        }).then(r => r.json());
    }

    loadConfig = () => {
        this.setState({ isLoaded: true });
        fetch(`/formatos/get_format_task_config/${this.props.format.id}`, {
            headers: { "X-CSRF-Token": this.token, "Content-Type": "application/json" }
        })
            .then(r => r.json())
            .then(data => {
                this.setState({
                    config: data.config,
                    questions: data.questions || [],
                    columns: data.columns || [],
                    statusOptions: data.status_options || [],
                    isLoaded: false,
                });
            });
    }

    notify = (data) => {
        Swal.fire({ position: "center", type: data.type, title: data.success, showConfirmButton: false, timer: 1200 });
    }

    toggleEnabled = () => {
        const enabled = !this.state.config.enabled;
        this.request(`/formatos/format_task_configs/${this.state.config.id}`, "PATCH", { enabled })
            .then(data => {
                this.notify(data);
                if (data.type !== "error") this.loadConfig();
            });
    }

    setStatusQuestion = (opt) => {
        this.request(`/formatos/format_task_configs/${this.state.config.id}`, "PATCH", { status_question_id: opt ? opt.value : null })
            .then(data => {
                this.notify(data);
                if (data.type !== "error") this.loadConfig();
            });
    }

    // ---- Mapeo de campos (campo fijo -> pregunta) ----
    fieldMappingFor = (taskField) =>
        (this.state.config.field_mappings || []).find(m => m.task_field === taskField);

    questionOptions = (types) =>
        this.state.questions
            .filter(q => types.includes(q.type))
            .map(q => ({ value: q.id, label: q.name }));

    onFieldChange = (taskField, opt) => {
        const existing = this.fieldMappingFor(taskField);
        let promise;
        if (!opt && existing) {
            promise = this.request(`/formatos/format_task_field_mappings/${existing.id}`, "DELETE");
        } else if (opt && existing) {
            promise = this.request(`/formatos/format_task_field_mappings/${existing.id}`, "PATCH", { question_id: opt.value });
        } else if (opt && !existing) {
            promise = this.request(`/formatos/format_task_field_mappings`, "POST", {
                format_task_config_id: this.state.config.id, task_field: taskField, question_id: opt.value
            });
        } else {
            return;
        }
        promise.then(data => { this.notify(data); if (data.type !== "error") this.loadConfig(); });
    }

    // ---- Mapeo de estados (columna <-> opción) ----
    statusMappingFor = (columnId) =>
        (this.state.config.status_mappings || []).find(m => m.column_id === columnId);

    availableOptions = (columnId) => {
        const used = (this.state.config.status_mappings || [])
            .filter(m => m.column_id !== columnId)
            .map(m => m.option_value);
        return this.state.statusOptions
            .filter(o => !used.includes(o))
            .map(o => ({ value: o, label: o }));
    }

    onStatusChange = (columnId, opt) => {
        const existing = this.statusMappingFor(columnId);
        let promise;
        if (!opt && existing) {
            promise = this.request(`/formatos/format_task_status_mappings/${existing.id}`, "DELETE");
        } else if (opt && existing) {
            promise = this.request(`/formatos/format_task_status_mappings/${existing.id}`, "PATCH", { option_value: opt.value });
        } else if (opt && !existing) {
            promise = this.request(`/formatos/format_task_status_mappings`, "POST", {
                format_task_config_id: this.state.config.id, column_id: columnId, option_value: opt.value
            });
        } else {
            return;
        }
        promise.then(data => { this.notify(data); if (data.type !== "error") this.loadConfig(); });
    }

    render() {
        const { config, isLoaded } = this.state;
        if (isLoaded || !config) {
            return <div className="p-3 text-center text-muted">Cargando...</div>;
        }

        const statusQuestionValue = config.status_question_info
            ? { value: config.status_question_info.id, label: config.status_question_info.name }
            : null;

        return (
            <div className="row p-3">
                <div className="col-md-12">
                    <h5 className='ui-index-configurationFormat-subtitle-tab'>Convertir registros en tareas</h5>

                    <div className="custom-control custom-switch mt-2 mb-3">
                        <input
                            type="checkbox"
                            className="custom-control-input"
                            id="customTaskSync"
                            checked={!!config.enabled}
                            onChange={this.toggleEnabled}
                        />
                        <label className="custom-control-label" htmlFor="customTaskSync">
                            Al completar un registro de este formato, crear/actualizar una tarea sincronizada.
                        </label>
                    </div>

                    {config.enabled && config.auto_task_board_token && (
                        <a
                            href={`/task/task_boards/${config.auto_task_board_token}/tasks`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-sm btn-outline-info mb-3"
                        >
                            <i className="fas fa-external-link-alt mr-1"></i> Abrir tablero de tareas del formato
                        </a>
                    )}

                    {config.enabled && (
                        <React.Fragment>
                            {/* SECCIÓN A — Mapeo de campos */}
                            <h6 className="mt-3" style={{ fontWeight: 700 }}>Campos de la tarea</h6>
                            <p className="text-muted" style={{ fontSize: 12 }}>
                                Elige qué campo del formato alimenta cada campo de la tarea.
                            </p>
                            <table className="table table-sm">
                                <thead>
                                    <tr><th style={{ width: "35%" }}>Campo de la tarea</th><th>Pregunta del formato</th></tr>
                                </thead>
                                <tbody>
                                    {TASK_FIELDS.map(field => (
                                        <tr key={field.key}>
                                            <td style={{ verticalAlign: "middle", fontWeight: 600 }}>{field.label}</td>
                                            <td>
                                                <Select
                                                    options={this.questionOptions(field.types)}
                                                    value={(() => {
                                                        const m = this.fieldMappingFor(field.key);
                                                        return m && m.question_info
                                                            ? { value: m.question_info.id, label: m.question_info.name }
                                                            : null;
                                                    })()}
                                                    onChange={(opt) => this.onFieldChange(field.key, opt)}
                                                    placeholder="Sin mapear"
                                                    className="link-form"
                                                    isClearable
                                                />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                            {/* SECCIÓN B — Estado */}
                            <h6 className="mt-4" style={{ fontWeight: 700 }}>Estado (columnas del tablero)</h6>
                            <p className="text-muted" style={{ fontSize: 12 }}>
                                Elige la pregunta select/radio que representa el estado y conecta cada columna del
                                tablero con una opción.
                            </p>
                            <div style={{ maxWidth: 480, marginBottom: 12 }}>
                                <label style={{ fontWeight: 600, fontSize: 12 }}>Pregunta de estado</label>
                                <Select
                                    options={this.questionOptions(STATUS_QUESTION_TYPES)}
                                    value={statusQuestionValue}
                                    onChange={this.setStatusQuestion}
                                    placeholder="Sin pregunta de estado"
                                    className="link-form"
                                    isClearable
                                />
                            </div>

                            {config.status_question_info && (
                                <table className="table table-sm">
                                    <thead>
                                        <tr><th style={{ width: "35%" }}>Columna del tablero</th><th>Opción del registro</th></tr>
                                    </thead>
                                    <tbody>
                                        {this.state.columns.map(col => (
                                            <tr key={col.id}>
                                                <td style={{ verticalAlign: "middle", fontWeight: 600 }}>{col.title}</td>
                                                <td>
                                                    <Select
                                                        options={this.availableOptions(col.id)}
                                                        value={(() => {
                                                            const m = this.statusMappingFor(col.id);
                                                            return m ? { value: m.option_value, label: m.option_value } : null;
                                                        })()}
                                                        onChange={(opt) => this.onStatusChange(col.id, opt)}
                                                        placeholder="Sin mapear"
                                                        className="link-form"
                                                        isClearable
                                                    />
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            )}
                        </React.Fragment>
                    )}
                </div>
            </div>
        );
    }
}

export default Index;
